import * as React from 'react';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { Card, CardContent, Typography, Stack, Box, LinearProgress, Divider, Button, Accordion, AccordionSummary, AccordionDetails, IconButton } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid } from '@mui/x-data-grid';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ReactInterval from 'react-interval';
import { BarChart } from '@mui/x-charts/BarChart';

export interface IDatosPorVerticalChartState {
    data: any[];
}

export default class DatosPorVerticalChart extends React.Component<{}, IDatosPorVerticalChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Datos extraídos por cliente
                        </Typography>
                    </Box>
                    <BarChart
                        dataset={this.state.data}
                        xAxis={[{ scaleType: 'band', dataKey: 'label' }]}
                        series={[
                            { dataKey: 'value', label: 'Extracciones', color: '#91bce2' }
                        ]}
                        height={350}
                        margin={{
                            bottom: 100
                        }}
                        slotProps={
                            {
                                legend: {
                                    direction: 'row',
                                    position: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    },
                                    itemMarkWidth: 20,
                                    itemMarkHeight: 6,
                                    markGap: 5,
                                    itemGap: 10,
                                    labelStyle: {
                                        fontSize: 11
                                    }
                                }
                            }
                        }
                    />
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/extracciones/data/byvertical`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            const data: any[] = [];
            
            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.label = response[i].name;
                dataItem.value = response[i].total;

                data.push(dataItem);
            }

            const dataWithColors = Common.SetColors(data);
            
            this.setState({
                data: dataWithColors
            })
        })
    }
}